import {
  getApprovalsList,
  getApprovalsDetail,
  auditApprovals
} from "@/api/approvals";

const state = {
};

const mutations = {
};

const actions = {
  auditapprovals({commit},pram){
    return new Promise((resolve, reject) => {
      auditApprovals(pram).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getapprovalslist({commit}){
    return new Promise((resolve, reject) => {
      getApprovalsList().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getapprovalsdetail({commit},pram){
    return new Promise((resolve, reject) => {
      getApprovalsDetail(pram).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
